(function () {
  SingleSlotService.$inject = ["API_URL", "$http", "$q", "$location", "$timeout", "$rootScope"];
  angular.module('calendarApp').service('SingleSlotService', SingleSlotService);

  function SingleSlotService(API_URL, $http, $q, $location, $timeout, $rootScope) {
    this.reserveSlot = function (shift) {
      var deferred = $q.defer();
      var appointment = {
        shiftid: shift._id,
        serviceid: shift.timeslots[0].serviceid,
        servicename: shift.serviceName,
        start: shift.timeslots[0].start,
        end: shift.timeslots[0].end,
        date: shift.date
      };

      if (shift.timeslots[0].hasresource) {
        appointment.hasresource = true;
        appointment.resourceid = shift.timeslots[0].resourceid;
        appointment.resourcename = shift.resourceName;
      } else {
        appointment.hasresource = false;
      }

      if (shift.isworkshop) {
        appointment.workshopshiftid = shift._id;
      }

      $rootScope.throbber.show(); // Now save the appointments tentatively to the server (and to local storage)

      $http.post(API_URL + '/api/v1/calendar/appointment/reserve', {
        appointments: [appointment],
        orgid: smooth.orgid
      }).then(function (reply) {
        $rootScope.throbber.hide();
        var response = reply.data;

        if (response.orgidmismatch) {
          $rootScope.throbber.showError('Sorry but you are logged into the calendar for the wrong organisation. You will need to login again.');
          $timeout(function () {
            $rootScope.customerInfo = null;
            localStorage.removeItem('calendar-jwt-token');
            $location.path('#/login');
            $rootScope.safeApply();
          }, 3000);
          return;
        }

        if (!response.success) {
          return $rootScope.throbber.showError("Sorry but an error occurred with this request: ".concat(response.msg, ". Please contact support@smoothbook.co if this error persists"));
        } // It's possible that there are no allowable appointments and this is an empty array.


        if (!response.appointments || !Array.isArray(response.appointments)) {
          response.appointments = [];
        }

        localStorage.setItem('reserved-appointments', JSON.stringify(response.appointments)); // Handle overbooked appointments

        if (response.overbooked) {
          $rootScope.overBooked = [];
          $rootScope.overBooked = response.overbookedappointments;
          $location.path('/overbooked/chooseslots');
          return;
        }

        deferred.resolve();
      }).catch(function (err) {
        $rootScope.throbber.showError("Sorry but an error occurred with this request: ".concat(err.message, ". Please contact support@smoothbook.co if this error persists"));
      });
      return deferred.promise;
    };
  }
})();